export default function createImage(name) {
  const findHTTPS = name?.includes('https');

  return {
    name,
    url: findHTTPS ? name : name,
  };
}
